import { useEffect } from "react"
import { SectionWrapper } from "../Section"
import "./styles.scss"

const HeaderBack = ({ title, handleGoBack, children }) => {

  return (
    <SectionWrapper className="header-screen">
      <div className="header-screen-button-title">
        <button className="back-button" onClick={handleGoBack}>
          <i className="fi fi-sr-arrow-small-left" />
        </button>
        <div className="title">{title}</div>
      </div>
      {children}
    </SectionWrapper>
  )
}

export default HeaderBack
